import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  EventEmitter,
  Output,
  SimpleChanges,
} from "@angular/core";
import * as dayjs from "dayjs";
import { CompsDataService } from "../comps-data.service";

@Component({
  selector: "app-comps-grid-filters",
  templateUrl: "./comps-grid-filters.component.html",
  styleUrls: ["./comps-grid-filters.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class CompsGridFiltersComponent implements OnInit {
  @Input() sources: string[];
  @Input() source: string;
  @Input() currency: string;
  @Input() filterData: {
    allPeriods: Array<number>;
    yearType: {};
    dataView: Array<any>;
  };
  @Input() othercurrencies: Array<any>;
  @Input() compType: string;
  @Input() currentTabType: string;
  @Input() metaReady: boolean;
  @Input() leftModalDataReady: boolean;
  @Input() updateMetaReady: boolean;
  @Input() apiEP: string = window.apiUrl;
  @Input() periodsWithAvailableData;
  @Output() saveCurrency = new EventEmitter();
  @Output() saveSource = new EventEmitter();
  @Output() saveDataview = new EventEmitter();
  @Output() saveYearType = new EventEmitter();
  @Output() setPeriod = new EventEmitter();

  displaySuggested = true;
  currencyOptionList: Array<any> = [
    { iso_currency: "Base" },
    { iso_currency: "USD", symbol: "$" },
    { iso_currency: "EUR", symbol: "$" },
    { iso_currency: "JPY", symbol: "$" },
  ];
  selectedCurrency: string;
  selectedSource: string;
  selectedDataView: string;
  selectedYear = "";
  dataviewApplied = false;
  yearTypeApplied = false;
  yearTypePopoverOpen = false;
  popoverOpen = false;
  dataViewFilterVisible = false;
  yearTypeFilterVisible = false;
  YearViewFilterVisible = false;
  customDate = null;
  checkOptions = [
    { label: "Values", value: "values", checked: false },
    { label: "YoY%", value: "yoy", checked: false },
  ];
  radioValue = "";
  errMsg = "";
  dvErrMsg = "";
  radioCalType = "";
  radioValueFrom: string;
  radioValueTo: string;
  radioValueYear: string;
  inValidCustomDate = false;
  radioValuePeriodFrom: string;
  radioValuePeriodTo: string;
  radioValuePeriod: string;
  invalidDataview = false;
  periodToCall = "";
  constructor(private dataService: CompsDataService) {}

  ngOnInit() {
    // this.onCurrencyListchanges();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.sources && changes.sources.currentValue) {
      this.sources = changes.sources.currentValue;
    }
    if (changes.othercurrencies && changes.othercurrencies.currentValue) {
      this.onCurrencyListchanges();
    }
    if (changes.currency && changes.currency.currentValue) {
      this.selectedCurrency = changes.currency.currentValue;
      // this.currency = changes.currency.currentValue;
    }
    if (changes.source && changes.source.currentValue) {
      this.selectedSource = changes.source.currentValue;
    }
    if (changes.filterData && changes.filterData.currentValue) {
      this.filterData = changes.filterData.currentValue;
      if (
        this.filterData.dataView &&
        this.filterData.dataView["view_by"][0] !== "revision"
      ) {
        this.radioValue = "";
        for (let i = 0; i < 2; i++) {
          this.checkOptions[i].checked = this.filterData.dataView[
            "view_by"
          ].includes(this.checkOptions[i].value)
            ? true
            : false;
        }
        if (this.filterData.dataView["view_by"].length < 2) {
          this.selectedDataView =
            this.filterData.dataView["view_by"][0] === "values"
              ? "Values"
              : "YoY%";
        } else {
          this.selectedDataView = "Values,YoY%";
        }
      } else if (this.filterData.dataView["revision"]) {
        if (this.filterData.dataView["revision"].startsWith("custom")) {
          this.radioValue = "custom";
          this.customDate = this.filterData.dataView["revision"].split("|")[1];
          this.selectedDataView = this.customDate;
        } else {
          this.radioValue = this.filterData.dataView["revision"];
          this.selectedDataView =
            this.filterData.dataView["revision"][0] === "1"
              ? `&Delta; ${this.filterData.dataView["revision"][0]} month`
              : `&Delta; ${this.filterData.dataView["revision"][0]} months`;
        }
      }
    }
  }

  onCurrencyListchanges() {
    const currInSuggested = this.currencyOptionList.filter(
      (item) => item.iso_currency.toUpperCase() === this.currency.toUpperCase(),
    );
    const curr = this.othercurrencies.filter(
      (item) => item.iso_currency.toUpperCase() === this.currency.toUpperCase(),
    );
    if (currInSuggested.length === 0 && curr.length !== 0) {
      this.currencyOptionList.push(curr[0]);
    }
  }

  onCurrencySearch(value: string) {
    if (value && value.length > 0) {
      this.currencyOptionList = this.othercurrencies.filter(
        (item) => item.iso_currency.indexOf(value.toUpperCase()) > -1,
      );
      this.displaySuggested = false;
    } else {
      this.currencyOptionList = [
        { iso_currency: "Base" },
        { iso_currency: "USD", symbol: "$" },
        { iso_currency: "EUR", symbol: "$" },
        { iso_currency: "JPY", symbol: "$" },
      ];
      this.displaySuggested = true;
    }
  }

  onCurrencyChange(selectedVal) {
    if (selectedVal && selectedVal.length > 0) {
      this.saveCurrency.emit(selectedVal);
    }

    //this.dataService.saveCurrency(this.tabId, selectedVal);
  }

  onSourceChange(selectedVal) {
    this.saveSource.emit(selectedVal);
  }

  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen) {
      this.dataviewApplied = false;
    }
    if (!this.popoverOpen && !this.dataviewApplied) {
      this.onResetDataView();
    }
  }

  yearTypePopoverChange() {
    this.yearTypePopoverOpen = !this.yearTypePopoverOpen;
    if (this.yearTypePopoverOpen) {
      this.yearTypeApplied = false;
    }
    if (!this.yearTypePopoverOpen && !this.yearTypeApplied) {
      this.onResetYearType();
    }
  }

  handlePeriodApply(event) {
    this.saveYearType.emit(event);
  }

  saveCompsYearType(params) {
    this.saveYearType.emit(params);
  }

  setCompsPeriod(param) {
    this.setPeriod.emit(param);
  }

  onDateChange() {
    if (this.customDate !== null) {
      this.inValidCustomDate = false;
    }
    this.radioValue = "custom";
  }

  applyDataView() {
    let viewBy = [];
    if (
      !this.radioValue &&
      !this.checkOptions[0].checked &&
      !this.checkOptions[1].checked
    ) {
      this.invalidDataview = true;
      // this.dv  = "Please select a value";
    } else {
      this.invalidDataview = false;
      this.dvErrMsg = "";
      if (this.radioValue !== "") {
        let revision = "";
        let dateStr = "";
        viewBy = ["revision"];
        switch (this.radioValue) {
          case "1m":
            this.inValidCustomDate = false;
            this.selectedDataView = "&Delta; 1 month";
            dateStr = dayjs().subtract(30, "day").format("MM-DD-YYYY");
            //  revision = `1m|${dateStr.toString()}`;
            revision = `1m`;
            break;
          case "3m":
            this.inValidCustomDate = false;
            this.selectedDataView = "&Delta; 3 months";
            dateStr = dayjs().subtract(90, "day").format("MM-DD-YYYY");
            revision = `3m`;
            break;
          case "custom":
            if (this.customDate === null) this.inValidCustomDate = true;
            else {
              this.inValidCustomDate = false;
              dateStr = dayjs(this.customDate).format("MM-DD-YYYY");
              this.selectedDataView = dateStr;
              //c=dayjs(dateStr).locale('en').from(dayjs().format("MM-DD-YYYY"));
              //mon = dayjs().diff(dayjs(this.customDate), "months");
              // days = dayjs().diff(dayjs(this.customDate), 'days');
              //days = new Date().getDate() - this.customDate.getDate();
              // c=dayjs(dayjs.now() - (this.customDate.getTime()/100))
              // .format('Y[Y] M[M] D[D]')
              // if(mon > 0)
              //   revision += `-${mon}M ${days}D|${dateStr}`;
              // else if(mon === 0 && days>0)
              //   revision += `-${days}D|${dateStr}`;
              // else if(mon === 0 && days === 0)
              //   revision += `${days}D|${dateStr}`;
              revision = `custom|${dateStr}`;
            }
            break;
          default:
            break;
        }
        this.setDataView(revision, viewBy);
      } else {
        this.inValidCustomDate = false;
        //console.log(this.checkOptions);
        if (this.checkOptions[0].checked && this.checkOptions[1].checked) {
          this.selectedDataView = "Values,YoY%";
          this.setDataView("", ["values", "yoy"]);
        } else {
          if (this.checkOptions[0].checked) {
            this.selectedDataView = this.checkOptions[0].label;
            this.setDataView("", ["values"]);
          }
          if (this.checkOptions[1].checked) {
            this.selectedDataView = this.checkOptions[1].label;
            this.setDataView("", ["yoy"]);
          }
        }
      }
    }

    //this.inValidCustomDate
  }

  setDataView(revision, viewBy) {
    if (!this.inValidCustomDate) {
      this.dataViewFilterVisible = false;
      this.dataviewApplied = true;
      this.saveDataview.emit({ viewBy, revision });
    }
  }

  disabledCustomDate = (customValue: Date): boolean => {
    return customValue >= dayjs().toDate();
  };

  radioValChange() {
    this.checkOptions.map((option) => {
      option.checked = false;
      return { ...option };
    });
  }

  chkboxOptChange() {
    this.radioValue = "";
  }

  onResetDataView() {
    this.dataViewFilterVisible = false;
    if (
      this.filterData.dataView &&
      this.filterData.dataView["view_by"][0] !== "revision"
    ) {
      this.radioValue = "";
      for (let i = 0; i < 2; i++) {
        this.checkOptions[i].checked = this.filterData.dataView[
          "view_by"
        ].includes(this.checkOptions[i].value)
          ? true
          : false;
      }
      if (this.filterData.dataView["view_by"].length < 2) {
        this.selectedDataView =
          this.filterData.dataView["view_by"][0] === "values"
            ? "Values"
            : "YoY%";
      } else {
        this.selectedDataView = "Values,YoY%";
      }
    } else {
      for (let i = 0; i < 2; i++) {
        this.checkOptions[i].checked = false;
      }
      if (this.filterData.dataView["revision"].startsWith("custom")) {
        this.radioValue = "custom";
        this.customDate = this.filterData.dataView["revision"].split("|")[1];
      } else {
        this.radioValue = this.filterData.dataView["revision"];
      }
    }
    //this.selectedDataView = "Values";
    //this.applyDataView();
  }

  onResetYearType() {
    this.yearTypeFilterVisible = false;
    this.radioCalType = this.filterData.yearType["type"];
    this.radioValuePeriod = this.filterData.yearType["period"];
    this.radioValueYear = this.filterData.yearType["year"];
  }

  //  changeFromRadio(val){
  //  }
}
